export default __webpack_public_path__ + "locales/sq-AL/Payments.json?hash=3da44fbab0b79123533feb06c5292f0f";